import { AVATAR_IMAGES } from "./constants";

const totalAvatars = AVATAR_IMAGES.length;

type GetUserAvatar = (userId: number) => string;
export const getUserAvatar: GetUserAvatar = userId => {
  const index = userId % totalAvatars;
  return AVATAR_IMAGES[index];
};
